var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex box",class:{ 'box--no-right': _vm.noRight, 'jcsb': !_vm.noRight },style:(_vm.headerStyle)},[_c('div',{staticClass:"left"},[_vm._t("left")],2),_c('div',{staticClass:"middle"},[_vm._t("middle")],2),_c('div',{staticClass:"right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }